import clsx from 'clsx';
import * as React from 'react';
import css from './badge.module.scss';
import { Badge as BaseBadge } from '@mui/base/Badge';

type Props = {
  variant?: 'default' | 'inline' | 'standalone';
  color?: 'default' | 'primary' | 'success' | 'error';
  size?: 'default' | 'small';
  dimmed?: boolean;
};

function Badge({
  children,
  badgeContent,
  expand,
  variant = 'default',
  color = 'default',
  size = 'default',
  dimmed,
  ...rest
}: React.ComponentProps<typeof BaseBadge> & Props) {
  return (
    <BaseBadge
      {...rest}
      badgeContent={badgeContent}
      slotProps={{
        root: {
          className: clsx(
            css.root,
            expand && css['is-expanded'],
            variant && css[`variant-${variant}`],
            color && css[`color-${color}`],
            size === 'small' && css['size-small'],
          ),
        },
        badge: {
          className: css.badge,
          ...(dimmed ? { style: { opacity: 0.5 } } : {}),
        },
      }}
    >
      {children}
    </BaseBadge>
  );
}

export default Badge;
